<template>
  <div>
    <h1>Proszę wybrać datę wyjścia do kina</h1>
    <input
      v-model="inputDate"
      class="form-control"
      type="date"
      @focusout="updateDate"
    >
  </div>
</template>

<script>
export default {
  name: 'CinemaForm',
  props: {
    date: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      inputDate: this.$props.date
    }
  },
  methods: {
    updateDate () {
      this.$emit('updateDate', this.inputDate)
    }
  }
}
</script>
